import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-audit-history-view',
  templateUrl: './audit-history-view.component.html',
  styleUrls: ['./audit-history-view.component.scss'],
})
export class AuditHistoryViewComponent implements OnInit {

  entityName: any;
  id: any;
  heading: any;

  expandedMap: { [key: string]: boolean } = {};
  allData: any;

  constructor(
    private _modalController: ModalController,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
  }

  closeModal() {
    this._modalController.dismiss();
  }

  formatChangeValue(field: string, value: string): string {
    if (!value) {
      return '--';
    }

    if (field === 'Lead Notes') {
      try {
        let validJsonStr = value.trim();

        if (!validJsonStr.startsWith('[')) {
          validJsonStr = `[${validJsonStr}]`;
        }

        const arr = JSON.parse(validJsonStr);
        if (Array.isArray(arr)) {
          return arr
            .map(item => {
              const noteText = `Notes: ${item.note || '--'}`;
              const userText = `User Name: ${item.userName || '--'}`;
              const formattedDate = item.createDate
                ? this.datePipe.transform(item.createDate, 'MMM d, yyyy')
                : '--';
              const createText = `Created Date: ${formattedDate}`;
              return `${noteText} | ${userText} | ${createText}`;
            })
            .join('<br><br>');
        }
      } catch (e) {
        console.error('Invalid JSON for Notes field:', value);
        return value;
      }
    }

    if (field === 'Hotel Notes') {
      try {
        // Remove HTML tags
        let cleaned = value.replace(/<[^>]*>/g, '');

        // Remove quotes
        cleaned = cleaned.replace(/"/g, '').trim();

        // If empty after cleaning, return --
        return cleaned ? cleaned : '--';
      } catch (e) {
        console.error('Invalid value for Hotel Notes field:', value);
        return value;
      }
    }

    if (field === 'Documents') {
      try {
        let validJsonStr = value.trim();

        // Wrap in array if needed
        if (!validJsonStr.startsWith('[')) {
          validJsonStr = `[${validJsonStr}]`;
        }

        const arr = JSON.parse(validJsonStr);

        return arr.map((item: any) => {
          const category = `Document Category: ${item.documentCategory || '--'}`;
          const fileName = `File Name: ${item.fileName || '--'}`;
          const path = item.path
            ? `<a href="${item.path}" target="_blank">${item.fileName || 'View Document'}</a>`
            : 'Path: --';

          return `${category} | ${fileName} | ${path}`;
        }).join('<br><br>');


      } catch (e) {
        console.error('Invalid value for Documents field:', value);
        return value;
      }
    }
   
    if (
      field === 'data' ||
      field === 'landPackages' ||
      field === 'include' ||
      field === 'exclude' ||
      field === 'termsAndConditions' ||
      field === 'paymentTermsAndConditions' ||
      field === 'cancellationPolicys' ||
      field === 'Vehicle Details' ||
      field === 'Room Details And Pricing' ||
      field === 'destination' ||
      field === 'destinations' ||
      field === 'daytodayPlan' ||
      field === 'passengerInfo' ||
      field === 'status' ||
      field === 'documents' ||
      field === 'mandatoryDocuments.data' ||
      field === 'documentsBasedOnVisa.data' ||
      field === 'otherDocuments.data' ||
      field === 'keyPoints.data' ||
      field === 'restrictedItems.data' ||
      field === 'importantNotes.data' ||
      field === 'detailsAboutStay.data' ||
      field === 'Company Phone' ||
      field === 'Enquiry Number 1' ||
      field === 'Enquiry Number 2' ||
      field === 'Modules' ||
      field === 'importantInformation'

    ) {
      return this.formatGenericJsonV2(field, value);
    }

    if (field === 'accommodations') {
      try {
        let validJsonStr = value.trim();

        // Parse the JSON string
        const obj = JSON.parse(validJsonStr);

        if (!obj.data || !Array.isArray(obj.data)) {
          return '--';
        }

        return obj.data.map((item: any) => {
          const bookingId = `Booking ID: ${item.bookingId || '--'}`;
          const location = `Location: ${item.location || '--'}`;
          const hotelName = `Hotel Name: ${item.hotelName || '--'}`;
          const totalRooms = `Total Rooms: ${item.totalRooms || '--'}`;
          const roomCategory = `Room Category: ${item.roomCategory || '--'}`;
          const hotelType = `Hotel Type: ${item.hotelType || '--'}`;
          const guestName = `Guest Name: ${item.guestName || '--'}`;
          const adults = `Adults: ${item.adults || 0}`;
          const childrens = `Children: ${item.childrens || 0}`;
          const checkIn = item.checkIn
            ? this.datePipe.transform(item.checkIn, 'MMM d, yyyy, h:mm a')
            : '--';
          const checkOut = item.checkOut
            ? this.datePipe.transform(item.checkOut, 'MMM d, yyyy, h:mm a')
            : '--';

          return [
            bookingId,
            location,
            hotelName,
            totalRooms,
            roomCategory,
            hotelType,
            guestName,
            adults,
            childrens,
            `Check In: ${checkIn}`,
            `Check Out: ${checkOut}`
          ].join(' | ');

        }).join('<br><br>');

      } catch (e) {
        console.error('Invalid value for accommodations field:', value);
        return value;
      }
    }

    if (
      field === 'transportations' ||
      field === 'routeCraft' ||
      field === 'inclusionAndExclusions' ||
      field === 'cancellationPolicies'
    ) {
      return this.formatGenericJson(value);
    }


    if (field === 'importantInformations') {
      try {
        if (!value) return '--';
        const obj = JSON.parse(value);

        if (!obj.data || !Array.isArray(obj.data)) return '--';

        return obj.data.map((item: any) => {
          return Object.keys(item)
            .map(k => `${this.formatKeyName(k)}: ${item[k]}`)
            .join(' | ');
        }).join('<br><br>');

      } catch (e) {
        console.error('Invalid JSON for importantInformation field:', value);
        return value;
      }
    }

    if (field === 'invoiceItems') {
      try {
        if (!value) return '--';

        let validJsonStr = value.trim();

        // Wrap in array if not already an array
        if (!validJsonStr.startsWith('[')) {
          validJsonStr = `[${validJsonStr}]`;
        }

        const arr = JSON.parse(validJsonStr);

        if (!Array.isArray(arr)) return '--';

        return arr.map((item: any) => {
          return Object.keys(item)
            .filter(k => k !== 'index')
            .map(k => `${this.formatKeyName(k)}: ${item[k]}`)
            .join(' | ');
        }).join('<br><br>');

      } catch (e) {
        console.error('Invalid JSON for invoiceItems field:', value);
        return value;
      }
    }
    return value;
  }


  private formatGenericJson(value: string): string {
    try {
      if (!value) return '--';

      let validJsonStr = value.trim();
      const obj = JSON.parse(validJsonStr);

      // Find first array property inside the object
      const arrayPropKey = Object.keys(obj).find(k => Array.isArray(obj[k]));

      if (!arrayPropKey) {
        return '--';
      }

      const arr = obj[arrayPropKey];

      return arr.map((item: any) => {
        // For nested arrays like bookingDetails
        const nestedArrayOutputs = Object.keys(item)
          .filter(k => Array.isArray(item[k]))
          .map(k => {
            return item[k].map((nestedItem: any) => {
              return Object.keys(nestedItem).map(nk => {
                return `${this.formatKeyName(nk)}: ${nestedItem[nk] || '--'}`;
              }).join(' | ');
            }).join('<br>');
          });

        // For normal properties
        const flatProps = Object.keys(item)
          .filter(k => !Array.isArray(item[k]))
          .map(k => {
            let val = item[k];

            if (Array.isArray(val)) {
              val = val.join(', ');
            }

            if (typeof val === 'string' && /\d{2}\/\d{2}\/\d{4}|\d{4}-\d{2}-\d{2}/.test(val)) {
              const parsedDate = new Date(val);
              if (!isNaN(parsedDate.getTime())) {
                val = this.datePipe.transform(parsedDate, 'MMM d, yyyy, h:mm a') || val;
              }
            }

            return `${this.formatKeyName(k)}: ${val || '--'}`;
          });

        return [...flatProps, ...nestedArrayOutputs].join(' | ');

      }).join('<br><br>');

    } catch (e) {
      console.error('Invalid JSON for dynamic formatter:', value);
      return value;
    }
  }

   private formatGenericJsonV2(field: string, value: string): string {
  try {
    if (!value) return '--';

    let validJsonStr = value.trim();

    if (!validJsonStr.startsWith('[')) {
      validJsonStr = `[${validJsonStr}]`;
    }

    const arr = JSON.parse(validJsonStr);

    return arr.map((item: any) => {
      return this.formatObject(item);
    }).join('<br><br>');

  } catch (e) {
    console.error(`Invalid value for ${field} field:`, value);
    return value;
  }
}


private formatObject(obj: any): string {
  return Object.keys(obj).map(key => {

    let val = obj[key];

    // If array
    if (Array.isArray(val)) {
      return val.map(v => {
        if (typeof v === 'object') {
          return this.formatObject(v);
        }
        return `${this.formatKeyName(key)}: ${v || '--'}`;
      }).join('<br>');
    }

    // If nested object
    if (typeof val === 'object' && val !== null) {
      return this.formatObject(val);
    }

    // If date string
    if (typeof val === 'string' && /\d{4}-\d{2}-\d{2}/.test(val)) {
      const parsedDate = new Date(val);
      if (!isNaN(parsedDate.getTime())) {
        val = this.datePipe.transform(parsedDate, 'MMM d, yyyy, h:mm a') || val;
      }
    }

    return `${this.formatKeyName(key)}: ${val || '--'}`;

  }).join(' | ');
}


  private formatKeyName(key: string): string {
    // Convert camelCase or PascalCase to spaced words
    return key
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
      .replace(/^./, str => str.toUpperCase());
  }


  getShortenedHtml(field: string, value: string): string {
    const key = field + value; // unique key for this cell
    const formatted = this.formatChangeValue(field, value);

    if (formatted.length <= 100) {
      return formatted;
    }

    if (this.expandedMap[key]) {
      return `${formatted} <span class="read-toggle">...Read less</span>`;
    } else {
      return `${formatted.substring(0, 100)} <span class="read-toggle">...Read more</span>`;
    }

  }

  toggleExpanded(change: any, valueType: 'oldValue' | 'newValue') {
    const field = change.field;
    const value = change[valueType];
    const key = field + value;
    this.expandedMap[key] = !this.expandedMap[key];
  }

}
